import { render, staticRenderFns } from "./VideoBase.vue?vue&type=template&id=5c2ab4fd&"
import script from "./VideoBase.vue?vue&type=script&lang=js&"
export * from "./VideoBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports